"use client";

import { usePathname } from "next/navigation";
import AuthGuard from "@/components/AuthGuard";
import AppNavBar from "@/components/nav/AppNavBar";
import { useUserStore, useHydrated } from "@/store/userStore";

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const user = useUserStore((s) => s.user);
  const hydrated = useHydrated();

  // Root page handles its own auth (login vs dashboard)
  if (pathname === "/") {
    if (hydrated && user) {
      return (
        <>
          <AppNavBar />
          {children}
        </>
      );
    }
    return <>{children}</>;
  }

  return (
    <AuthGuard>
      <AppNavBar />
      {children}
    </AuthGuard>
  );
}
